/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
export var Status;
(function (Status) {
    Status["READY"] = "ready";
    Status["BUSY"] = "busy";
    Status["SUCCESS"] = "success";
    Status["ERROR"] = "error";
})(Status || (Status = {}));
export var mergeStatus = function (status) {
    if (status.find(function (value) { return value === Status.ERROR; }) !== undefined) {
        return Status.ERROR;
    }
    if (status.find(function (value) { return value === Status.BUSY; }) !== undefined) {
        return Status.BUSY;
    }
    if (status.find(function (value) { return value === Status.READY; }) !== undefined) {
        return Status.READY;
    }
    return Status.SUCCESS;
};
